import { Component } from '@verndale/core';

class SubMenu extends Component {
  breakpoint = window.matchMedia('(min-width: 1280px)');
  isMobile = false;
  offsetTop = 0;

  constructor(el: HTMLElement) {
    super(el);

    this.handleBreakpoint();
    this.checkViewportWidth();
    this.setCommonCardHeight();
    this.addEventListeners();
  }

  setupDefaults() {
    this.dom = {
      menuItems: this.el.querySelectorAll<HTMLElement>('.sub-menu__item'),
      cards: this.el.querySelectorAll<HTMLElement>('.sub-menu__card'),
      content: this.el.querySelector<HTMLElement>('.sub-menu__content'),
      asideContainer: this.el.querySelector<HTMLElement>('aside'),
      asideImages: this.el.querySelectorAll<HTMLElement>('.sub-menu__image'),
      progressBar: this.el.getElementsByClassName(
        'sub-menu__progress'
      )[0] as HTMLElement
    };
    if (
      this.dom.menuItems instanceof NodeList &&
      this.dom.menuItems.length > 0
    ) {
      this.dom.menuItems[0].classList.add('sub-menu__item--active');
    }
    if (
      this.dom.asideImages instanceof NodeList &&
      this.dom.asideImages.length > 0
    ) {
      this.dom.asideImages[0].classList.remove('hidden');
    }
  }

  addEventListeners() {
    this.breakpoint.addEventListener(
      'change',
      this.handleBreakpoint.bind(this)
    );
    document.addEventListener('scroll', this.updateProgressBar.bind(this));
    (this.dom.menuItems as NodeListOf<HTMLElement>).forEach(menuItem => {
      menuItem.addEventListener('click', this.handleMenuItemClick.bind(this));
    });

    // create an Observer instance
    const resizeObserver = new ResizeObserver(() => this.getAnchor());

    // start observing a DOM node
    resizeObserver.observe(document.body);
  }

  getAnchor() {
    const anchor =
      document.URL.split('#').length > 1 ? document.URL.split('#')[1] : null;

    if (anchor) {
      const el = document.getElementById(anchor);
      if (el) {
        window.scrollTo({
          top: el.offsetTop - 180,
          behavior: 'smooth'
        });
      }
    }
  }

  checkViewportWidth() {
    this.isMobile =
      !window.matchMedia(`(min-width: ${768}px)`).matches &&
      !window.matchMedia(`(min-width: ${1440}px)`).matches;
  }

  handleBreakpoint() {
    this.offsetTop = this.breakpoint.matches ? 160 : 0;
  }

  handleMenuItemClick(event: MouseEvent) {
    event.preventDefault();
    const target = event.target as HTMLAnchorElement;
    const id = target.dataset.scrollTo;

    if (id) {
      const el = document.getElementById(id.replace('#', ''));
      if (el) {
        window.scrollTo({
          top: el.offsetTop - 170,
          behavior: 'smooth'
        });
      }
    }
  }

  setCommonCardHeight() {
    if (!this.isMobile) {
      const cards = this.dom.cards as NodeListOf<HTMLElement>;
      let maxHeight = 0;

      (cards || []).forEach(card => {
        card.style.height = 'auto';
        if (card.offsetHeight > maxHeight) {
          maxHeight = card.offsetHeight;
        }
      });

      (cards || []).forEach(card => {
        card.style.height = `${maxHeight}px`;
      });

      if (this.dom.asideContainer instanceof HTMLElement) {
        this.dom.asideContainer.style.height = `${maxHeight}px`;
      }
    }
  }

  updatePicture(index: number) {
    const asideImages = this.dom.asideImages as NodeListOf<HTMLElement>;
    (asideImages || []).forEach((image, i) => {
      image.classList.add('hidden');
      if (i === index) {
        image.classList.remove('hidden');
      }
    });
  }

  updateProgressBar() {
    const container = this.dom.content as HTMLElement;
    const menuItems = this.dom.menuItems as NodeListOf<HTMLElement>;
    const portions: { color: string; percent: number }[] = [];
    const progressBar = this.dom.progressBar as HTMLElement;

    const containerHeight = container.getBoundingClientRect().height;
    const topPosition = -(
      container.getBoundingClientRect().top - this.offsetTop
    );

    let progress = (100 * topPosition) / containerHeight;

    if (progress < 0) {
      progress = 0;
    } else if (progress > 100) {
      progress = 100;
    }

    (menuItems || []).forEach((item: HTMLElement, index: number) => {
      portions.push({
        color: item.dataset.color || 'transparent',
        percent: (100 / (menuItems.length || 1)) * (index + 1)
      });
      item.classList.remove('sub-menu__item--active');
    });

    portions.some((portion, index) => {
      if (progress <= portion.percent) {
        if (progressBar) {
          [
            'red',
            'purple',
            'dark-blue',
            'orange',
            'yellow',
            'light-blue',
            'green'
          ].forEach(color => {
            progressBar.classList.remove(`sub-menu__progress--${color}`);
          });
          progressBar.classList.add(`sub-menu__progress--${portion.color}`);
          progressBar.style.width = progress + '%';

          if (menuItems && menuItems[index]) {
            this.updatePicture(index);
            menuItems[index].classList.add('sub-menu__item--active');
          }
          return true;
        }
      }
      return false;
    });
  }
}

export default SubMenu;
